import { convertStdDateString } from "./convertStdDateString";
import type { QChange } from "../CoreApp/QChange";
import type { QObjDBObject } from "../CoreApp/QObjDBObject";

export const GetFlattenedChanges = (override?: QObjDBObject) => {
  const changes: QChange[] = [...(override?.fChanges ?? [])];

  const fallbackDate = Number.MAX_SAFE_INTEGER;
  const sortedChanges = changes.sort((a, b) => {
    const aDateStr = a.GetChangeDate();
    const bDateStr = b.GetChangeDate();
    const aParsed = aDateStr ? convertStdDateString(aDateStr).getTime() : NaN;
    const bParsed = bDateStr ? convertStdDateString(bDateStr).getTime() : NaN;
    // Dates absent or in a format convertStdDateString cannot handle (e.g. the
    // UTC string written by OverrideFactory) fall back to a max sentinel so
    // these changes always sort last and win the last-write-wins reduction.
    // Note: this differs from QPlanManager.js (which maps null → 0/epoch) because
    // QPlanManager sorts for display only, whereas here the order drives a
    // last-write-wins reduction where the latest change must win.
    const aDate = Number.isFinite(aParsed) ? aParsed : fallbackDate;
    const bDate = Number.isFinite(bParsed) ? bParsed : fallbackDate;
    return aDate - bDate;
  });

  return sortedChanges.reduce(
    (acc, change) => {
      if (change.IsReverted()) {
        return acc;
      }

      return {
        ...acc,
        ...change.fDelta
      };
    },
    {} as Record<string, unknown>
  );
};
